import React from "react";
import {typeSeasonService} from "../jwt/_services/clasificator/typeSeasonService";

export const typeSeasonProvider = {
    getOptions,
    getItem,
};

async function getOptions(){
    try {
        const listItems = await typeSeasonService.getAll();

        return listItems.map((itemData) => {
            const { id, name } = itemData
            return (
                {
                    id: id,
                    value: name,
                    label: <div><label>{name}</label></div>
                }
            )
        });
    } catch (error) {
        throw error;
    }
}

async function getItem(id){
    try {
        const item = await typeSeasonService.getItem(id);
        return (
            {
                id: item.id,
                value: item.name,
                label: <div><label>{item.name}</label></div>}
        );
    } catch (error) {
        throw error;
    }
}